import { render, staticRenderFns } from "./postPrice.vue?vue&type=template&id=373df84a&"
import script from "./postPrice.vue?vue&type=script&lang=js&"
export * from "./postPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports